import { Card, SectionHeader, ConfidenceBar } from "../../components/lib";
import { COHORTS } from "../../mocks/growthData";

export default function Retention() {
  return (
    <div className="space-y-6" data-testid="gr-retention">
      <Card testId="gr-r-cohorts">
        <SectionHeader eyebrow="Cohorts" title="Customer retention by cohort" />
        <div className="space-y-3">
          {COHORTS.map((c) => (
            <div key={c.cohort} data-testid={`gr-co-${c.cohort}`} className="grid items-center gap-3" style={{ gridTemplateColumns: "1.2fr 3fr 3fr 3fr 3fr 1fr" }}>
              <div>
                <div className="text-sm font-semibold" style={{ color: "var(--ph-ink-strong)" }}>{c.cohort}</div>
                <div className="text-[10px] tabular-nums" style={{ color: "var(--ph-ink-muted)" }}>{c.customers} customers</div>
              </div>
              {[["W1", c.w1], ["W4", c.w4], ["W8", c.w8], ["W12", c.w12]].map(([label, v]) => (
                <div key={label as string}>
                  <div className="text-[10px] mb-0.5" style={{ color: "var(--ph-ink-muted)" }}>{label}</div>
                  <ConfidenceBar value={v as number}/>
                  <div className="text-[10px] tabular-nums mt-0.5" style={{ color: "var(--ph-ink-muted)" }}>{Math.round((v as number)*100)}%</div>
                </div>
              ))}
              <div className="text-right"><div className="text-[10px]" style={{ color: c.w12 > 0.32 ? "var(--ph-success)" : "var(--ph-warning)" }}>{c.w12 > 0.32 ? "healthy" : "watch"}</div></div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
